import { FC } from 'react';
import { cn } from '../cn';
import { SVG_ICONS } from '../icons';

/** One notch of a puzzle's difficulty. `full` is the coral piece, `empty` its outline. */
export const PuzzlePiece: FC<{ style: 'full' | 'empty'; className?: string }> = ({ style, className }) => {
  const Piece = style === 'full' ? SVG_ICONS.puzzlePieceFull : SVG_ICONS.puzzlePieceEmpty;
  return <Piece className={className && cn(className)} />;
};
